document.addEventListener('DOMContentLoaded', function(e: Event) {
    if ((e as any).isTrusted) {
        const w = window as any;
        const assetId = '~/theme/v1/Views/Custom/Page/PageContent/PageContentExpandable.min.js';

        if (w.umwAssets && w.umwAssets[assetId] && w.umwAssets[assetId].length) {

            for (const ctx of w.umwAssets[assetId]) {

                const uc224 = document.querySelector<HTMLElement>(`#${ctx.uniqueID}`);
                const showMoreBtn: string = ctx.showMore;
                const showLessBtn: string = ctx.showLess;

                const limitRows: number = ctx.LimitRows;
                const lineHeight: number = ctx.lineHeight;

                const minHeight = limitRows * lineHeight * 16; // 16px is default font-size

                if (uc224) {
                    const btnToggle = uc224.querySelector<HTMLElement>('.js-uc224-toggle-btn');
                    const text = uc224.querySelector<HTMLElement>('.uc224-description');

                    if (btnToggle && text) {
                        if (minHeight >= text.scrollHeight) {
                            // Content is short enough to not need expanding
                            btnToggle.remove();
                        } else {
                            btnToggle.addEventListener('click', () => {
                                if (text.classList.contains('uc224-description-min')) {
                                    btnToggle.innerHTML = showLessBtn;
                                    text.classList.remove('uc224-description-min');
                                } else {
                                    btnToggle.innerHTML = showMoreBtn;
                                    text.classList.add('uc224-description-min');
                                }
                            });
                        }
                    }
                }
            }
        }
    }
});